var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVariationHigh = function SvgVariationHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 15.534c-1.018-.608-2.098-1.656-3.291-3.2A1 1 0 0 1 4.29 11.11c1.125 1.456 2.025 2.283 2.734 2.706.68.406 1.132.415 1.463.32.378-.11.79-.409 1.263-.958.471-.546.916-1.234 1.408-1.998l.02-.032c.47-.727.984-1.526 1.555-2.189.576-.67 1.3-1.307 2.225-1.574.974-.28 1.995-.1 3.041.525 1.018.608 2.098 1.656 3.291 3.2a1 1 0 0 1-1.582 1.223c-1.125-1.456-2.025-2.283-2.734-2.706-.68-.406-1.132-.415-1.463-.32-.379.11-.79.409-1.263.958-.471.546-.916 1.233-1.408 1.998l-.021.032c-.468.727-.983 1.526-1.554 2.189-.576.67-1.3 1.307-2.225 1.574-.974.28-1.995.1-3.041-.525Z",
    clipRule: "evenodd"
  })));
};

export default SvgVariationHigh;